const ApiConfig = {
  protocol: process.env.REACT_APP_PROTOCOL,
  apiUri: process.env.REACT_APP_API,

  irqEndpoint: "/uswf-task-quote/quotes",
  irqListEndpoint: "/uswf-task-quote/quotes",
  irqInfoEndpoint: "/uswf-task-quote",
  propertyTypeEndpoint: "/uswf-task-quote/property-type",
};

export default ApiConfig;
